import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomMixerToRotateEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerToRotateEventVO.validationSchema()
  );

  constructor(readonly value: RoomMixerToRotateEvent) {
    JsonSchemaValidator.assert(RoomMixerToRotateEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      },
      additionalProperties: false
    };
  }
}

interface RoomMixerToRotateEvent {
  roomId: RoomId;
}
